import { Tag } from "antd";
import React from "react";

function ColorTags(props) {
  return (
    <div>
      <Tag color={props.color} style={{ fontWeight: "700 !important" }}>
        {props.name}
      </Tag>
    </div>
  );
}

export default ColorTags;
